import { TranslateService } from '@ngx-translate/core';

const DEFAULT_LOCALE = 'es-ES';

let translateService: TranslateService | null = null;

export function registerI18n(service: TranslateService): void {
  translateService = service;
}

export function translate(
  key: string,
  params?: Record<string, unknown>,
  fallback?: string
): string {
  if (!translateService) {
    return fallback ?? key;
  }
  const translated = translateService.instant(key, params);
  if (typeof translated !== 'string') {
    return fallback ?? key;
  }
  if (translated === key && fallback) {
    return fallback;
  }
  return translated;
}

export function currentLocale(): string {
  return translateService?.currentLang || DEFAULT_LOCALE;
}
